import { createContext } from 'react';

/** Consumed through the useAuth hook, never directly. */
export const AuthContext = createContext(null);
